import { auth, posts, sites } from './apiUrl';
import { request } from '../../../service/common';

//현장 목록 조회
export const getSites = async ({ memberId }) => {
  const { data } = await request.get(sites.list, {
    params: { memberId },
  });
  return data.datas;
};

//현장 등록
export const postSites = async ({ memberId, siteName, siteAlias, siteAddress, geometry, memo }) => {
  const { data } = await request.post(sites.add, { memberId, siteName, siteAlias, siteAddress, geometry, memo });
  return data;
};

//현장 상세 조회
export const getSiteDetail = async ({ siteId }) => {
  const { data } = await request.get(sites.detail(siteId));
  return data.datas;
};

//현장 메모 수정
export const putSiteMemo = async ({ siteId, memo }) => {
  const { data } = await request.put(sites.memo(siteId), { memo });
  return data;
};
